import React from 'react'
import { InputTextarea } from 'primereact/inputtextarea'

export default function LtsTextArea(props) {
  const {
    label,
    hidden,
    value,
    name,
    cols,
    disabled,
    autoResize = true,
    onChange: onChangeProp,
    ...restProps
  } = props

  const onChange = (event) => {
    onChangeProp?.(event.target.value)
  }

  return (
    <span className="p-float-label">
      <InputTextarea
        {...restProps}
        value={value}
        onChange={onChange}
        name={name}
        cols={cols ?? 30}
        autoResize={autoResize}
        disabled={disabled}
      />
      {label && !hidden && <label>{label}</label>}
    </span>
  )
}
